import { useState } from 'react'

import { useDebounce, useForm } from '@domain-group/react-hooks'

import useAgencyProviderPackage from '@hooks/useAgencyProviderPackage'
import useSelector from '@hooks/useSelector'

import { AgencyProviderPackageModel } from '@models/types'

const requiredFields = [
  { key: 'provider_package_id' },
]

const defaultState = {
  brand_id: undefined,
  brand_group_id: undefined,
  provider_id: undefined,
  string: '',
}

const useBulkCreateAgencyProviderPackagesModal = (agencyProviderPackage: Partial<AgencyProviderPackageModel> = {}) => {
  const { agency_id, provider_package_id } = agencyProviderPackage

  const [selectedEntityIds, setSelectedEntityIds] = useState<number[]>([])

  const {
    callbacks: { bulkCreateAgencyProviderPackages },
    creating,
    providerPackage,
  } = useAgencyProviderPackage(agencyProviderPackage)

  const { agencies, providerPackages } = useSelector(reduxState => reduxState.entities)

  const entityParams = agency_id
    ? { agency_id, provider_package_ids: selectedEntityIds }
    : { agency_ids: selectedEntityIds, provider_package_id }

  const searchForm = useForm(
    defaultState,
    {
      entity: { provider_package_id },
      requiredFields,
      validateOn: 'change',
    },
  )

  const {
    entityState: {
      string,
    },
  } = searchForm

  const debouncedString = useDebounce(string, 200)

  return {
    agencies,
    callbacks: {
      bulkCreateAgencyProviderPackages,
      setSelectedEntityIds,
    },
    creating,
    debouncedString,
    entityParams,
    providerPackage,
    providerPackages,
    saveEnabled: (agency_id || provider_package_id) && !!selectedEntityIds.length,
    searchForm,
    selectedEntityIds,
  }
}

export default useBulkCreateAgencyProviderPackagesModal
